import { render, staticRenderFns } from "./ContactLinks.vue?vue&type=template&id=6b639636"
import script from "./ContactLinks.vue?vue&type=script&lang=js"
export * from "./ContactLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports